import { FORMATTING_BUTTONS, ToolbarType } from '@wix/ricos';

export const getInlineToolbarSetting = (shouldUseFontSize = false) => {
  return {
    name: ToolbarType.INLINE,
    shouldCreate: () => ({
      desktop: true,
      mobile: { android: true, ios: true },
    }),
    getButtons: () => {
      const desktopButtons = [
        FORMATTING_BUTTONS.HEADINGS,
        '|',
        ...(shouldUseFontSize ? [FORMATTING_BUTTONS.FONT_SIZE, '|'] : []),
        FORMATTING_BUTTONS.BOLD,
        FORMATTING_BUTTONS.ITALIC,
        FORMATTING_BUTTONS.UNDERLINE,
        FORMATTING_BUTTONS.STRIKETHROUGH,
        FORMATTING_BUTTONS.TEXT_COLOR,
        FORMATTING_BUTTONS.TEXT_HIGHLIGHT,
        '|',
        FORMATTING_BUTTONS.LINK,
        '|',
        FORMATTING_BUTTONS.TITLE,
        FORMATTING_BUTTONS.BLOCKQUOTE,
        FORMATTING_BUTTONS.CODE_BLOCK,
        FORMATTING_BUTTONS.SPOILER,
        '|',
        FORMATTING_BUTTONS.ALIGNMENT,
        '|',
        FORMATTING_BUTTONS.ORDERED_LIST,
        FORMATTING_BUTTONS.UNORDERED_LIST,
        '|',
        FORMATTING_BUTTONS.INCREASE_INDENT,
        FORMATTING_BUTTONS.DECREASE_INDENT,
        '|',
        FORMATTING_BUTTONS.LINE_SPACING,
      ];

      const mobileButtons = [
        FORMATTING_BUTTONS.HEADINGS,
        FORMATTING_BUTTONS.BOLD,
        FORMATTING_BUTTONS.ITALIC,
        FORMATTING_BUTTONS.UNDERLINE,
        FORMATTING_BUTTONS.STRIKETHROUGH,
        FORMATTING_BUTTONS.TEXT_COLOR,
        FORMATTING_BUTTONS.LINE_SPACING,
      ];
      return {
        desktop: desktopButtons,
        mobile: {
          android: mobileButtons,
          ios: mobileButtons,
        },
      };
    },
  };
};

export const mobileButtons = [
  'AddPlugin',
  '|',
  FORMATTING_BUTTONS.UNDO,
  FORMATTING_BUTTONS.REDO,
  '|',
  FORMATTING_BUTTONS.HEADINGS,
  FORMATTING_BUTTONS.BOLD,
  FORMATTING_BUTTONS.ITALIC,
  FORMATTING_BUTTONS.UNDERLINE,
  FORMATTING_BUTTONS.STRIKETHROUGH,
  FORMATTING_BUTTONS.TEXT_COLOR,
  FORMATTING_BUTTONS.TEXT_HIGHLIGHT,
  '|',
  FORMATTING_BUTTONS.LINK,
  '|',
  FORMATTING_BUTTONS.BLOCKQUOTE,
  FORMATTING_BUTTONS.CODE_BLOCK,
  FORMATTING_BUTTONS.SPOILER,
  '|',
  FORMATTING_BUTTONS.ALIGNMENT,
  '|',
  FORMATTING_BUTTONS.ORDERED_LIST,
  FORMATTING_BUTTONS.UNORDERED_LIST,
  '|',
  FORMATTING_BUTTONS.LINE_SPACING,
];

export const formattingToolbarSetting = {
  name: ToolbarType.FORMATTING,
  shouldCreate: () => ({ desktop: true, mobile: { android: true, ios: true } }),
  getButtons: () => {
    const desktopButtons = [
      FORMATTING_BUTTONS.HEADINGS,
      '|',
      FORMATTING_BUTTONS.BOLD,
      FORMATTING_BUTTONS.ITALIC,
      FORMATTING_BUTTONS.UNDERLINE,
      FORMATTING_BUTTONS.STRIKETHROUGH,
      FORMATTING_BUTTONS.TEXT_COLOR,
      FORMATTING_BUTTONS.TEXT_HIGHLIGHT,
      FORMATTING_BUTTONS.TITLE,
      FORMATTING_BUTTONS.BLOCKQUOTE,
      '|',
      FORMATTING_BUTTONS.ALIGN_GROUP,
      FORMATTING_BUTTONS.ORDERED_LIST,
      FORMATTING_BUTTONS.UNORDERED_LIST,
      FORMATTING_BUTTONS.DECREASE_INDENT,
      FORMATTING_BUTTONS.INCREASE_INDENT,
      '|',
      FORMATTING_BUTTONS.LINE_SPACING,
      FORMATTING_BUTTONS.LINK,
      FORMATTING_BUTTONS.CODE_BLOCK,
    ];

    const mobButtons = [
      FORMATTING_BUTTONS.HEADINGS,
      FORMATTING_BUTTONS.BOLD,
      FORMATTING_BUTTONS.ITALIC,
      FORMATTING_BUTTONS.UNDERLINE,
      FORMATTING_BUTTONS.STRIKETHROUGH,
      FORMATTING_BUTTONS.TEXT_COLOR,
      FORMATTING_BUTTONS.LINE_SPACING,
    ];
    return {
      desktop: desktopButtons,
      mobile: {
        android: mobButtons,
        ios: mobButtons,
      },
    };
  },
};
